import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch recruiters
export const fetchAllRecruiters = createAsyncThunk(
    'recruiters/fetchAllRecruiters',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('api/v1/get_all_recruiters');
            return response.data;
        } catch (err) {
            console.error("Error fetching recruiters:", err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const recruitersSlice = createSlice({
    name: 'recruiters',
    initialState: {
        allRecruiters: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllRecruiters(state, action) {
            state.allRecruiters = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllRecruiters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllRecruiters.fulfilled, (state, action) => {
                state.loading = false;
                state.allRecruiters = action.payload;
            })
            .addCase(fetchAllRecruiters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllRecruiters } = recruitersSlice.actions;
export default recruitersSlice.reducer;
